// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Croatia from '../_raw/flag/icon_flag_croatia.png';

export default () => <img src={Croatia} alt="Croatia" />;
